import "./Testimonial.css";
import { AiFillStar } from "react-icons/ai";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/bundle";

const TestimonialData = [
  {
    name: "Rajesh Kumar",
    review:
      "Thanks to Curative Physio, I found relief from chronic pain and improved my mobility.",
  },
  {
    name: "Priya Sharma",
    review:
      "Curative Physio is a game-changer. Better mobility and a pain-free life. A true blessing!",
  },
  {
    name: "Amit Patel",
    review:
      "Grateful for the personalized care. Curative Physio transformed my life. Highly recommended!",
  },
  {
    name: "Neha Verma",
    review:
      "Instant relief from nerve compression. Regained mobility. Reach out to them! One of the best Physiotherapist.",
  },
  {
    name: "Ramesh Singh",
    review:
      "Life-changing. Sciatica pain vanished, and I feel like a brand-new person. Thank you! Best recommended!",
  },
  {
    name: "Anita Reddy",
    review:
      "Remarkable progress in regaining my abilities and independence thanks to Curative Physio!",
  },
];

const Testimonial = () => {
  return (
    <>
      <section className="slider-wrapper">
        <div className="head">
          <h2>
            What our <span>patients</span> says?
          </h2>
        </div>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          autoplaySpeed={2}
          autoplay={true}
          loop={true}
          breakpoints={{
            100: {
              slidesPerView: 1,
            },
            700: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
          }}
          className="heroSlider"
        >
          {TestimonialData.map((value, index) => (
            <SwiperSlide>
              <div className="single-brand-logo" key={index}>
                <div className="card p-2 testimonial-card">
                  <div className="desc">
                    <p>{value.review}</p>
                  </div>
                  <div className="name">
                    <p className="text-muted">{value.name}</p>
                  </div>
                  <div className="star">
                    <AiFillStar />
                    <AiFillStar />
                    <AiFillStar />
                    <AiFillStar />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </>
  );
};

export default Testimonial;
